import { defineStore } from 'pinia'
import saasAPiClientCallBackend from '../saasAPiClientCallBackend.js'

export const useUserDetailsStore = defineStore('userDetailsStore', {
  state: () => ({
    userDetailsResponse: {},
    loaded: false
  }),
  getters: {
    getUserDetailsResponse (state) {
      return state.userDetailsResponse
    },
    getLoaded (state) {
      return state.loaded
    },
    getUsername (state) {
      if (typeof (state.userDetailsResponse.profile) === 'undefined') {
        return 'Not Loaded'
      }
      if (typeof (state.userDetailsResponse.profile.name) === 'undefined') {
        return 'Not Loaded'
      }
      if ((state.userDetailsResponse.profile.name === null) || (state.userDetailsResponse.profile.name === '')) {
        return 'Anon'
      }
      return state.userDetailsResponse.profile.name
    },
    getUserId (state) {
      if (typeof (state.userDetailsResponse.profile) === 'undefined') {
        return 'Not Loaded'
      }
      return state.userDetailsResponse.id
    },
    isBlocked (state) {
      return function (matrixUserId) {
        const a = state.userDetailsResponse.blocked_users.filter(function (x) {
          return x.matrix_id === matrixUserId
        })
        return a.length > 0
      }
    }
  },
  actions: {
    clear () {
      this.loaded = false
      this.userDetailsResponse = {}
    },
    saveRecievedData ({ response }) {
      this.loaded = true
      this.userDetailsResponse = response
    },
    refresh ({ force, router, tenantName, callback }) {
      console.log('REFRESH USER DETAILS')
      if (this.loaded) {
        if (!force) {
          // console.log('UserDetailsStore Reload skipped already loaded and not forced')
          if (typeof (callback) !== 'undefined') {
            callback.ok(this.userDetailsResponse)
          }
          return
        }
      }
      const internalCallback = {
        ok: function (response) {
          const recievedResponse = JSON.parse(JSON.stringify(response))
          userDetailStore.saveRecievedData({ response: recievedResponse.data })
          if (typeof (callback) !== 'undefined') {
            callback.ok(recievedResponse.data)
          }
        },
        error: function (response) {
          if (typeof (callback) !== 'undefined') {
            callback.error(response)
          }
        }
      }
      saasAPiClientCallBackend.callApi({
        prefix: 'entity',
        router,
        path: '/user/me',
        method: 'get',
        postdata: undefined,
        callback: internalCallback,
        tenantName
      })
    },
    updateProfile ({ router, tenantName, callback, profile }) {
      // intercept ok callback and update store state
      const callbackInternal = {
        ok: function (response) {
          const recievedResponse = JSON.parse(JSON.stringify(response))
          userDetailStore.saveRecievedData({ response: recievedResponse.data.user })
          callback.ok(response)
        },
        error: callback.error
      }
      saasAPiClientCallBackend.callApi({
        prefix: 'entity',
        router,
        path: '/user/me',
        method: 'put',
        postdata: {
          profile
        },
        callback: callbackInternal,
        tenantName
      })
    },
    block ({ router, tenantName, postData, callback }) {
      // Blocks the user and uses the response to update internal userinfo
      const callbackInternal = {
        ok: function (response) {
          const recievedResponse = JSON.parse(JSON.stringify(response))
          userDetailStore.saveRecievedData({ response: recievedResponse.data.user })
          callback.ok(response)
        },
        error: callback.error
      }
      saasAPiClientCallBackend.callApi({
        prefix: 'processes',
        router,
        path: '/block',
        method: 'post',
        postdata: postData,
        callback: callbackInternal,
        tenantName
      })
    },
    unblock ({ router, tenantName, matrixUserId, callback }) {
      const callbackInternal = {
        ok: function (response) {
          const recievedResponse = JSON.parse(JSON.stringify(response))
          userDetailStore.saveRecievedData({ response: recievedResponse.data.user })
          callback.ok(response)
        },
        error: callback.error
      }
      const postData = {
        user_to_unblock_matrix_user_id: matrixUserId
      }
      saasAPiClientCallBackend.callApi({
        prefix: 'processes',
        router,
        path: '/unblock',
        method: 'post',
        postdata: postData,
        callback: callbackInternal,
        tenantName
      })
    }
  }
})

const userDetailStore = useUserDetailsStore()
